import { connect } from 'react-redux';

import authOrCreateMessage from 'actions/messages/authOrCreateMessage';
import { getAttachmentsEnabled, getCompositionDraft, getCustomText, getUserComposition } from 'app/modules';
import InputValidationComposition from 'presentation/selfService/InputValidationComposition';
import uiEvents from 'events/ui';
import updateCustomerTypingState from 'actions/session/updateCustomerTypingState';

export const mapStateToProps = (state, props) => {
  let attachments = getUserComposition(state).attachments;
  let attachmentsEnabled = getAttachmentsEnabled(state);
  let currentInput = getCompositionDraft(state);
  let compositionText = getCustomText(state).composition;
  return {
    ...props,
    attachments: attachments,
    canAddAttachments: attachmentsEnabled && !attachments[0],
    compositionDraft: currentInput,
    hasContent: /\S+/.test(currentInput) || (attachmentsEnabled && !!attachments[0]),
    prompt: compositionText.messagePrompt,
    shouldAutoFocus: true,
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    onAttachmentChange: attachments => {
      dispatch(uiEvents.updateUserComposition({ attachments: attachments }));
    },
    onAttachmentError: error => {
      dispatch(uiEvents.updateAttachmentError(error));
    },
    onChange: (text, attachments) => {
      dispatch(uiEvents.updateUserComposition({ attachments: attachments, text: text }));
      dispatch(uiEvents.updateCompositionDraft(text));
    },
    onCustomerTypingStateUpdate: typingState => {
      dispatch(updateCustomerTypingState(typingState));
    },
    onSubmit: (message, attachments) => {
      dispatch(authOrCreateMessage(message, attachments));
      dispatch(uiEvents.updateUserComposition({ attachments: [], text: '' }));
      dispatch(uiEvents.updateCompositionDraft(''));
    },
    onValidate: () => true,
  };
};

const MessageValidationCompositionContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(InputValidationComposition);

export default MessageValidationCompositionContainer;
